module.exports = __webpack_public_path__ + "static/icon-timestamp-35c94e7d5fde7b43c8858169c2382626.png";